import { LoginIdentifier } from "@/io/repository/AuthRepository.ts";

export type LoginChannel = "sms" | "email";

export const oppositeChannel = (channel: LoginChannel): LoginChannel => (channel === "sms" ? "email" : "sms");

const NON_DIGITS = /[^0-9]/g;

export const PHONE_LENGTH = 10;

export const CODE_LENGTH = 6;

export const digitsOf = (value: string): string => value.replace(NON_DIGITS, "");

/** Groups digits by pairs as the patient types: 06 12 34 56 78. */
export const formatPhone = (value: string): string =>
  digitsOf(value)
    .slice(0, PHONE_LENGTH)
    .replace(/(\d\d)(?=\d)/g, "$1 ");

/**
 * Masks a contact for the "code sent to" label, keeping only what the patient
 * needs to recognize it: the first and last digits of a phone, the first letter
 * and domain of an e-mail.
 */
export const maskContact = (channel: LoginChannel, contact: string): string => {
  if (channel === "email") {
    const [local, domain] = contact.split("@");
    return domain && local ? `${local[0]}***@${domain}` : contact;
  }

  const digits = digitsOf(contact);
  return digits.length >= 4 ? `${digits.slice(0, 2)} ********${digits.slice(-2)}` : contact;
};

/** Turns a `{ channel, contact }` pair into the api's login identifier. */
export const identifierFrom = (channel: LoginChannel, contact: string): LoginIdentifier =>
  channel === "email" ? { email: contact.trim() } : { phone: digitsOf(contact) };
